// Auto-generated - DO NOT EDIT
export const pathMapping = {
  "get:/wello/v2/auth/wello-comment/{welloCommentId}": "getMetaPolicyCommentList",
  "put:/wello/v2/auth/wello-comment/{welloCommentId}": "updateWelloComment",
  "put:/wello/v2/auth/wello-comment/{welloCommentId}/delete": "deleteWelloComment",
  "get:/wello/v2/auth/wello-app-push": "getWebWelloAppPushList",
  "put:/wello/v2/auth/wello-app-push": "updateWelloAppPushRead",
  "post:/wello/v2/auth/s3": "fileUpload",
  "put:/wello/v2/auth/s3": "updateFileTempSaveYn",
  "delete:/wello/v2/auth/s3": "fileDelete",
  "put:/wello/v2/auth/s3/rename": "fileRename",
  "put:/wello/v2/auth/message-reject/member-wello": "rejectMessage",
  "put:/wello/v2/auth/member/verification": "updateMemberVerification",
  "get:/wello/v2/auth/member/profile": "member",
  "post:/wello/v2/auth/member/profile": "saveMemberNickName",
  "put:/wello/v2/auth/member/profile": "updateMemberNickName",
  "put:/wello/v2/auth/member/message-receive": "messageReceive",
  "get:/wello/v2/auth/member-wello/private_data_consent": "getPrivateDataConsent",
  "put:/wello/v2/auth/member-wello/private_data_consent": "updatePrivateDataConsent",
  "get:/wello/v2/auth/member-wello/location-service-consent": "getLocationServiceConsent",
  "put:/wello/v2/auth/member-wello/location-service-consent": "updateLocationServiceConsent",
  "get:/wello/v2/auth/member-card": "memberCardList",
  "post:/wello/v2/auth/member-card": "saveMemberCard",
  "put:/wello/v2/auth/member-card": "updateIssueAt",
  "put:/wello/v2/auth/member-card/card-image": "uploadCardImage",
  "put:/wello/v2/auth/localfesta/participant/entry": "updateLocalfestaParticipantEntry",
  "get:/wello/v2/auth/local-market/my/reviews/{reviewId}": "findMyReview",
  "put:/wello/v2/auth/local-market/my/reviews/{reviewId}": "updateMyReview",
  "delete:/wello/v2/auth/local-market/my/reviews/{reviewId}": "deleteMyReview",
  "put:/wello/v2/auth/local-market/checkouts/{beforeOrderId}/checkout": "checkout",
  "put:/wello/v2/auth/local-market/cart-items/{cartItemId}/quantity": "updateQuantity",
  "put:/wello/v2/auth/local-market/cart-items/{cartItemId}/option": "updateOption",
  "put:/wello/v2/auth/local-market-orders/{orderId}/vendors/{vendorId}/delivery-address": "updateVendorDeliveryAddress",
  "put:/wello/v2/auth/local-market-orders/{orderId}/return/{returnId}/cancel": "cancelReturn",
  "put:/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/confirm": "confirmOrderProduct",
  "put:/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/cancel": "cancelOrderProduct",
  "put:/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/cancel-all": "cancelProduct",
  "put:/wello/v2/auth/local-market-orders/{orderId}/order-products/cancel": "cancelOrderProducts",
  "put:/wello/v2/auth/local-market-orders/{orderId}/delivery-address": "updateAllDeliveryAddress",
  "put:/wello/v2/auth/local-market-orders/{orderId}/confirm": "confirmPurchase",
  "put:/wello/v2/auth/local-market-orders/{orderId}/cancel": "cancelOrder",
  "put:/wello/v2/auth/home/gift/order/{orderId}/status": "updateGiftOrderStatus",
  "put:/wello/v2/auth/home/gift/order/{orderId}/address": "updateGiftOrderAddress",
  "put:/wello/v2/auth/home/gift/cart-items/{giftCartItemOptionId}": "updateOptionItemList",
  "put:/wello/v2/auth/home/gift/cart-items/{giftCartItemOptionId}/increase": "increaseOptionQuantity",
  "put:/wello/v2/auth/home/gift/cart-items/{giftCartItemOptionId}/decrease": "decreaseOptionQuantity",
  "get:/wello/v2/auth/home/gift-review": "getGiftOrderProductReviewList",
  "post:/wello/v2/auth/home/gift-review": "saveGiftOrderProductReview",
  "put:/wello/v2/auth/home/gift-review": "updateGiftOrderProductReview",
  "put:/wello/v2/auth/home/event/december/random-ticket/{randomTicketId}": "openRandomTicket",
  "get:/wello/v2/auth/home/donation-business-comment": "getDonationBusinessCommentList",
  "post:/wello/v2/auth/home/donation-business-comment": "saveDonationBusinessComment",
  "put:/wello/v2/auth/home/donation-business-comment": "updateDonationBusinessComment",
  "delete:/wello/v2/auth/home/donation-business-comment": "deleteDonationBusinessComment",
  "get:/wello/v2/auth/home/delivery/{addressId}": "getDeliveryAddress",
  "put:/wello/v2/auth/home/delivery/{addressId}": "updateDeliveryAddress",
  "delete:/wello/v2/auth/home/delivery/{addressId}": "deleteDeliveryAddress",
  "get:/wello/v2/auth/home-inquiry/{homeInquiryId}": "getHomeInquiry",
  "put:/wello/v2/auth/home-inquiry/{homeInquiryId}": "saveHomeInquiry",
  "delete:/wello/v2/auth/home-inquiry/{homeInquiryId}": "deleteHomeInquiry",
  "get:/wello/v2/auth/family/profile": "getWelloMemberFamily",
  "post:/wello/v2/auth/family/profile": "saveWelloMemberFamily",
  "put:/wello/v2/auth/family/profile": "updateWelloMemberFamily",
  "put:/wello/v2/auth/dlp/seoul/account/password": "changeMemberPassword",
  "get:/wello/v1/auth/tour/festival/{tourId}/review/{reviewId}": "findTourReview",
  "put:/wello/v1/auth/tour/festival/{tourId}/review/{reviewId}": "updateTourReview",
  "delete:/wello/v1/auth/tour/festival/{tourId}/review/{reviewId}": "deleteTourReview",
  "post:/wello/v2/auth/wello-track": "saveWelloTracking",
  "post:/wello/v2/auth/wello-like": "saveWelloLike",
  "delete:/wello/v2/auth/wello-like": "deleteWelloLike",
  "post:/wello/v2/auth/wello-helper": "saveWelloHelper",
  "post:/wello/v2/auth/wello-event-participation": "saveWelloParticipation",
  "post:/wello/v2/auth/wello-device-info": "saveWelloDeviceInfo",
  "get:/wello/v2/auth/wello-comment": "getWelloCommentList",
  "post:/wello/v2/auth/wello-comment": "saveWelloComment",
  "post:/wello/v2/auth/wello-comment-report": "saveWelloCommentReport",
  "post:/wello/v2/auth/s3/re": "fileReUpload",
  "post:/wello/v2/auth/s3/copy": "fileCopy",
  "post:/wello/v2/auth/poll/{pollId}/vote": "createPollVote",
  "post:/wello/v2/auth/policy/dislike/{policyId}": "saveWishlist",
  "delete:/wello/v2/auth/policy/dislike/{policyId}": "removeWishlist",
  "post:/wello/v2/auth/policy-apply/report": "saveReport",
  "get:/wello/v2/auth/point/attendance": "getListPointAttendance",
  "post:/wello/v2/auth/point/attendance": "saveTodayAttendance",
  "post:/wello/v2/auth/point-market/product/{productIdIdx}/feedback": "feedbackPointMarketProduct",
  "post:/wello/v2/auth/point-market/order/reissue-coupon": "reissueCoupon",
  "post:/wello/v2/auth/point-market/order/payments": "payPointMarketOrder",
  "post:/wello/v2/auth/nice-safe-key": "sendNiceSafeKey",
  "post:/wello/v2/auth/member": "fileUpload1",
  "delete:/wello/v2/auth/member": "resignMember",
  "post:/wello/v2/auth/member/wishlist": "saveWishlist1",
  "delete:/wello/v2/auth/member/wishlist": "deleteWishlist",
  "post:/wello/v2/auth/member/kb-member-check": "kbMemberCheck",
  "post:/wello/v2/auth/member-wello/block/by-community/{communityId}": "blockWelloMemberByCommunity",
  "post:/wello/v2/auth/member-verification": "getLatestCompletedCi",
  "post:/wello/v2/auth/member-verification/info": "getLatestCompleted",
  "post:/wello/v2/auth/member-verification/decrypt": "decryptMemberVerification",
  "get:/wello/v2/auth/member-term-agreement": "getMemberTermAgreementByAgreementType",
  "post:/wello/v2/auth/member-term-agreement": "saveOrUpdateMemberTermAgreement",
  "post:/wello/v2/auth/member-oauth/logout": "logoutMember",
  "post:/wello/v2/auth/member-filter/region": "noticeList",
  "post:/wello/v2/auth/member-filter/kb": "saveKbFilter",
  "get:/wello/v2/auth/member-filter/interest": "interestFilter",
  "post:/wello/v2/auth/member-filter/interest": "saveInterestFilter",
  "post:/wello/v2/auth/member-filter/fit": "putFitFilter",
  "post:/wello/v2/auth/member-filter/fit-new": "saveFitFilter",
  "get:/wello/v2/auth/member-account": "memberAccountList",
  "post:/wello/v2/auth/member-account": "saveMemberAccount",
  "get:/wello/v2/auth/localfesta/participant": "getLocalfestaParticipantInfo",
  "post:/wello/v2/auth/localfesta/participant": "saveLocalfestaParticipant",
  "post:/wello/v2/auth/local-market/products/{productId}/inquiries": "saveInquiry",
  "post:/wello/v2/auth/local-market/payments/cancel": "cancelOrder1",
  "post:/wello/v2/auth/local-market/payments/approve": "approvePayment",
  "post:/wello/v2/auth/local-market/my/reviews/orders/{orderId}/products/{productId}": "saveReview",
  "post:/wello/v2/auth/local-market/coupons/{couponId}/download": "downloadCoupon",
  "post:/wello/v2/auth/local-market/coupons/download-all": "downloadAllCoupons",
  "post:/wello/v2/auth/local-market/coupons/applicable-for-products": "findApplicableCouponsForProducts",
  "get:/wello/v2/auth/local-market/cart-items": "findCartItems",
  "post:/wello/v2/auth/local-market/cart-items": "saveCartItem",
  "delete:/wello/v2/auth/local-market/cart-items": "deleteCartItems",
  "post:/wello/v2/auth/local-market/before-orders": "createBeforeOrder",
  "post:/wello/v2/auth/local-market/before-orders/{beforeOrderId}/dummy-complete": "dummyComplete",
  "post:/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/return-all": "returnProduct",
  "post:/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/exchange-all": "exchangeProduct",
  "post:/wello/v2/auth/local-market-orders/{orderId}/products/{orderProductId}/return": "requestReturn",
  "post:/wello/v2/auth/local-market-orders/{orderId}/order-products/return": "returnOrderProducts",
  "post:/wello/v2/auth/local-market-orders/{orderId}/order-products/exchange": "exchangeOrderProducts",
  "post:/wello/v2/auth/kb": "sendPinkey",
  "get:/wello/v2/auth/home/gift/cart-items": "findAllByMemberOAuthId",
  "post:/wello/v2/auth/home/gift/cart-items": "addCartItem",
  "delete:/wello/v2/auth/home/gift/cart-items": "deleteCartItems1",
  "post:/wello/v2/auth/home/donation/reservation": "createDonationReservation",
  "get:/wello/v2/auth/home/delivery": "getDeliveryAddressList",
  "post:/wello/v2/auth/home/delivery": "createDeliveryAddress",
  "post:/wello/v2/auth/home-love/member": "createMember",
  "post:/wello/v2/auth/home-love/donation/process": "processDonation",
  "post:/wello/v2/auth/home-love/donation/process/cart-item": "processDonationCart",
  "post:/wello/v2/auth/home-love/donation/complete": "completeDonation",
  "post:/wello/v2/auth/home-love/donation/check": "checkDonationAvailable",
  "post:/wello/v2/auth/home-love/donation/before-complete": "beforeCompleteDonation",
  "get:/wello/v2/auth/home-inquiry": "getHomeInquiryList",
  "post:/wello/v2/auth/home-inquiry": "saveHomeInquiry1",
  "post:/wello/v2/auth/home-donation-event": "applyHomeDonationEvent",
  "post:/wello/v2/auth/home-donation-event-preselection/draw": "drawEventPreselection",
  "post:/wello/v2/auth/home-donation-event-gift-box/open-all": "openAllEventGiftBox",
  "post:/wello/v2/auth/feed": "getFeedList",
  "post:/wello/v2/auth/dlp/seoul/loan-crdt-rcvr/check": "getDlpSeoulLoanCrdtRcvrCheck",
  "post:/wello/v2/auth/dlp/seoul/loan-crdt-rcvr/apply": "getDlpSeoulLoanCrdtRcvrApply",
  "post:/wello/v2/auth/dlp/seoul/islt-youth-sprt/check": "getDlpSeoulIsltYoungSprtCheck",
  "post:/wello/v2/auth/dlp/seoul/islt-youth-sprt/apply": "getDlpSeoulIsltYoungSprtApply",
  "post:/wello/v2/auth/dlp/seoul/cltr-pass/check": "getDlpSeoulCltrPassCheck",
  "post:/wello/v2/auth/dlp/seoul/cltr-pass/apply": "getDlpSeoulCulturePassApply",
  "post:/wello/v2/auth/dlp/seoul/applied-policy-list": "getDlpSeoulAppliedPolicyList",
  "post:/wello/v2/auth/dlp/seoul/account": "getDlpSeoulAccountAndRequestLogin",
  "post:/wello/v2/auth/dlp/seoul/account/verification": "requestDlpSeoulVerification",
  "post:/wello/v2/auth/dlp/seoul/account/verification/check": "requestDlpSeoulVerificationCheck",
  "post:/wello/v2/auth/dlp/seoul/account/password-verification": "requestDlpSeoulVerificationForPassword",
  "post:/wello/v2/auth/dlp/seoul/account/password-verification/check": "requestDlpSeoulVerificationCheckForPassword",
  "post:/wello/v2/auth/dlp/seoul/account/member-info": "getDlpSeoulMemberInfo",
  "post:/wello/v2/auth/dlp/seoul/account/login": "requestLogin",
  "post:/wello/v2/auth/dlp/seoul/account/join": "createAccount",
  "post:/wello/v2/auth/dlp/seoul/account/id/check": "requestDlpSeoulIdCheck",
  "post:/wello/v2/auth/dlp/gyeonggi/account/verification": "verifyDlpGyeonggiAccountIdentification",
  "post:/wello/v2/auth/dlp/gyeonggi/account/verification/check": "checkDlpGyeonggiAccountIdentification",
  "post:/wello/v2/auth/dlp/gyeonggi/account/login": "loginDlpGyeonggiAccount",
  "post:/wello/v2/auth/dlp/gyeonggi/account/join": "saveDlpGyeonggiAccount",
  "post:/wello/v2/auth/dlp/gyeonggi/account/id/check": "checkDlpGyeonggiAccountId",
  "get:/wello/v2/auth/cs/inquiry": "inquiryList",
  "post:/wello/v2/auth/cs/inquiry": "saveInquiry1",
  "post:/wello/v2/auth/community/{communityId}/report": "reportCommunity",
  "post:/wello/v2/auth/certification/check": "certificationCheck",
  "post:/wello/v2/auth/certification/cellphone": "sendCertificationCellphone",
  "post:/wello/v2/auth/benefit-notification/application-info": "saveBenefitNotificationApplicationInfo",
  "post:/wello/v1/auth/tour/festival/{tourId}/review": "saveTourReview",
  "get:/wello/v3/auth/local-market-orders/{orderId}/deliveries/{deliveryId}/tracking": "getDeliveryTracking",
  "get:/wello/v2/auth/wello-policy-code/reverse-geocoding": "authReverseGeocoding",
  "get:/wello/v2/auth/wello-policy-code/geolocation": "authGeolocation",
  "get:/wello/v2/auth/wello-like/my": "getListLikeContents",
  "get:/wello/v2/auth/wello-like/my/type": "getListLikeContentsType",
  "get:/wello/v2/auth/wello-comment/my": "getMyWelloCommentList",
  "get:/wello/v2/auth/wello-comment/live": "getLiveWelloCommentList",
  "get:/wello/v2/auth/tour/feedback/{tourId}": "findTourFeedback",
  "get:/wello/v2/auth/s3/decryption": "fileDecryptionDownload",
  "get:/wello/v2/auth/recommend-policy": "recommendPolicyList",
  "get:/wello/v2/auth/poll/{pollId}": "getPoll",
  "get:/wello/v2/auth/poll/{pollId}/voted": "checkVoted",
  "get:/wello/v2/auth/poll/{pollId}/result": "getPollResult",
  "get:/wello/v2/auth/policy": "metaPolicyList",
  "get:/wello/v2/auth/policy/{metaPolicyIdIdx}": "metaPolicy",
  "get:/wello/v2/auth/policy/policy/{metaPolicyIdIdx}/related": "getRelatedMetaPolicyList",
  "get:/wello/v2/auth/policy/interest-policy": "getInterestPolicyList",
  "get:/wello/v2/auth/policy/feedback/{policyId}": "metaPolicyFeedback",
  "get:/wello/v2/auth/policy/dislike": "dislike",
  "get:/wello/v2/auth/policy-case/baby/related-policy": "getListChildcareRelatedPolicy",
  "get:/wello/v2/auth/policy-apply/history": "getWelloPolicyApplyList",
  "get:/wello/v2/auth/policy-apply/history/count": "getWelloPolicyApplyCount",
  "get:/wello/v2/auth/policy-apply/check": "checkWelloPolicyApply",
  "get:/wello/v2/auth/point": "getDetailPointBalance",
  "get:/wello/v2/auth/point/history": "getListPointHistory",
  "get:/wello/v2/auth/point/event": "getPointBudget",
  "get:/wello/v2/auth/point-market/product/avail-point-product": "getAvailablePointProductList",
  "get:/wello/v2/auth/point-market/order": "getPointMarketOrderList",
  "get:/wello/v2/auth/point-market/order/preview": "getPointMarketOrderPreview",
  "get:/wello/v2/auth/payment-his": "paymentHisList",
  "get:/wello/v2/auth/payment-his/total-count": "totalPaymentHisList",
  "get:/wello/v2/auth/nice-safe-key/check-plus_fail": "checkPlusFail",
  "get:/wello/v2/auth/nice-safe-key/check-plus-send-result": "checkPlusSendResult",
  "get:/wello/v2/auth/member/wishlist/tour-festival": "getTourFestivalWishlist",
  "get:/wello/v2/auth/member/wishlist/policy": "metaPolicyWishlist",
  "get:/wello/v2/auth/member/wishlist/hometown-news": "hometownNewsWishlist",
  "get:/wello/v2/auth/member/wishlist/emergency-room": "getEmergencyRoomWishlist",
  "get:/wello/v2/auth/member/wishlist/community/wello-news": "getCommunityWelloNewsWishlist",
  "get:/wello/v2/auth/member/wishlist/best-contents": "bestContentsWishlist",
  "get:/wello/v2/auth/member/user-property": "userProperty",
  "get:/wello/v2/auth/member/social-accounts": "memberSocialAccounts",
  "delete:/wello/v2/auth/member/social-accounts": "deleteMemberSocialAccounts",
  "get:/wello/v2/auth/member/recent/recommend/policy": "memberRecommendPolicyByRecentList",
  "get:/wello/v2/auth/member/recent/policy": "memberRecentPolicyList",
  "get:/wello/v2/auth/member/policy/provision-type-count": "memberPolicyList",
  "get:/wello/v2/auth/member/peer-group/policy": "memberPeerGroupPolicyList",
  "get:/wello/v2/auth/member/neighbor/policy": "memberNeighborPolicyList",
  "get:/wello/v2/auth/member/invited-member-count": "getInvitedMemberCount",
  "get:/wello/v2/auth/member/interest/policy": "memberInterestPolicyList",
  "get:/wello/v2/auth/member/content-count": "memberContentCount",
  "get:/wello/v2/auth/member/action-count": "getActionCount",
  "get:/wello/v2/auth/member-wello/block": "getWelloMemberBlockList",
  "get:/wello/v2/auth/member-verification/info/detail": "getMemberDetailInfo",
  "get:/wello/v2/auth/member-verification/check": "getMemberVerificationId",
  "get:/wello/v2/auth/member-oauth/my-info": "getMember",
  "get:/wello/v2/auth/member-filter/required": "requiredFilter",
  "get:/wello/v2/auth/member-account/available": "getMemberAccount",
  "get:/wello/v2/auth/local-market/payments/terms": "findAllTerms",
  "get:/wello/v2/auth/local-market/payments/terms/{termsType}": "findTerms",
  "get:/wello/v2/auth/local-market/payments/config": "findPaymentConfig",
  "get:/wello/v2/auth/local-market/payment-methods": "findSimplePayMethods",
  "get:/wello/v2/auth/local-market/my/reviews": "findMyReviews",
  "get:/wello/v2/auth/local-market/my/reviews/orders/{orderId}/products/{productId}/form": "getReviewForm",
  "get:/wello/v2/auth/local-market/coupons/my": "findMyCoupons",
  "get:/wello/v2/auth/local-market/coupons/downloadable": "findDownloadableCoupons",
  "get:/wello/v2/auth/local-market/coupons/downloadable/exists": "existsDownloadableCoupon",
  "get:/wello/v2/auth/local-market/coupons/available": "findAvailableCoupons",
  "get:/wello/v2/auth/local-market/coupons/applicable": "findApplicableCoupons",
  "get:/wello/v2/auth/local-market/cart-items/product-options/{productId}": "getProductOptionsById",
  "get:/wello/v2/auth/local-market/cart-items/coupon-available": "findCouponAvailable",
  "get:/wello/v2/auth/local-market/before-orders/{beforeOrderId}": "getBeforeOrder",
  "get:/wello/v2/auth/local-market-orders": "findAllOrders",
  "get:/wello/v2/auth/local-market-orders/{orderId}": "findOrder",
  "get:/wello/v2/auth/local-market-orders/{orderId}/transaction-statement": "getTransactionStatement",
  "get:/wello/v2/auth/local-market-orders/{orderId}/refund-info": "getRefundInfo",
  "get:/wello/v2/auth/local-market-orders/{orderId}/receipt": "getReceipt",
  "get:/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/refund-info": "getProductRefundInfo",
  "get:/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/refund-estimate": "getRefundEstimate",
  "get:/wello/v2/auth/local-market-orders/{orderId}/products/{productId}/order-items": "getOrderItemsForAction",
  "get:/wello/v2/auth/local-market-orders/{orderId}/deliveries/{deliveryId}/tracking": "getDeliveryTracking1",
  "get:/wello/v2/auth/local-market-orders/unified": "findUnifiedOrders",
  "get:/wello/v2/auth/local-market-orders/by-number/{orderNo}": "findOrderByNumber",
  "get:/wello/v2/auth/kosaf/confirm-household-info-agreement": "confirmHouseholdInfoAgreement",
  "get:/wello/v2/auth/hometown-news/{hometownNewsIdIdx}": "hometownNews",
  "get:/wello/v2/auth/hometown-news/feedback/{hometownNewsId}": "hometownNewsFeedback",
  "get:/wello/v2/auth/home/institution/policy": "getHomeInstitutionPolicyList",
  "get:/wello/v2/auth/home/institution-event": "getHomeInstitutionEventList",
  "get:/wello/v2/auth/home/institution-event/ordered": "getOrderedHomeInstitutionEventList",
  "get:/wello/v2/auth/home/gift/order": "getGiftOrderHistoryList",
  "get:/wello/v2/auth/home/gift/order/{orderId}": "getGiftOrderHistory",
  "get:/wello/v2/auth/home/gift/order/{orderId}/delivery": "getDeliveryTracking2",
  "get:/wello/v2/auth/home/gift-review/{reviewId}": "getGiftOrderProductReview",
  "delete:/wello/v2/auth/home/gift-review/{reviewId}": "removeGiftOrderProductReview",
  "get:/wello/v2/auth/home/gift-review/my": "getMyGiftOrderProductReviewList",
  "get:/wello/v2/auth/home/event/december/random-ticket-count": "getDecemberRandomTicketCount",
  "get:/wello/v2/auth/home/delivery/primary": "getPrimaryDeliveryAddress",
  "get:/wello/v2/auth/home-notice": "getHomeNoticeList",
  "get:/wello/v2/auth/home-love/member/check": "checkMember",
  "get:/wello/v2/auth/home-love/main/institution-event": "getHomeLoveMainInstitutionEventList",
  "get:/wello/v2/auth/home-love/donation/latest-complete": "latestCompleteDonation",
  "get:/wello/v2/auth/home-inquiry/my": "getHomeInquiryMyList",
  "get:/wello/v2/auth/home-donation/my": "getMyDonationInfo",
  "get:/wello/v2/auth/home-donation/history": "getHomeDonationHistoryList",
  "get:/wello/v2/auth/home-donation/event/local-tour": "getEventLocalTour",
  "get:/wello/v2/auth/home-donation/epay-no/{epayNo}": "getHomeDonationHistory",
  "get:/wello/v2/auth/home-donation/certificate": "getHomeInstitutionCertificate",
  "get:/wello/v2/auth/home-donation/certificate/latest": "getLatestHomeInstitutionCertificate",
  "get:/wello/v2/auth/home-donation-event/participant": "getParticipantDonationEventList",
  "get:/wello/v2/auth/home-donation-event/is-progressing": "isEventInProgress",
  "get:/wello/v2/auth/home-donation-event-preselection/status": "preselectionStatus",
  "get:/wello/v2/auth/home-donation-event-history": "getEventHistoryList",
  "get:/wello/v2/auth/home-donation-event-history/summary": "getMyInviteEventHistorySummary",
  "get:/wello/v2/auth/home-donation-event-history/invitee-event/received": "getInviteeEventReceived",
  "get:/wello/v2/auth/home-donation-event-gift-box/unopened/indicators": "getUnopenedGiftBoxIndicators",
  "get:/wello/v2/auth/home-donation-event-gift-box/unopened/count": "getUnopenedEventGiftBoxCount",
  "get:/wello/v2/auth/home-donation-event-gift-box/summary": "getMyInviteEventGiftBoxSummary",
  "get:/wello/v2/auth/home-donation-event-gift-box/opened": "getOpenedEventGiftBoxList",
  "get:/wello/v2/auth/home-donation-event-gift-box/invitee-gift-box/received": "getInviteeGiftBoxReceived",
  "get:/wello/v2/auth/emergency-room": "getEmergencyRoomList",
  "get:/wello/v2/auth/emergency-room/{emergencyRoomId}": "getEmergencyRoom",
  "get:/wello/v2/auth/dlp/seoul/account/terms-of-service": "getDetailTermsOfService",
  "get:/wello/v2/auth/dlp/seoul/account/privacy-policy-first": "getDetailTermsOfPrivacy",
  "get:/wello/v2/auth/dlp/gyeonggi/account": "checkDlpGyeonggiAccount",
  "get:/wello/v2/auth/cs/inquiry/{inquiryId}": "getInquiry",
  "get:/wello/v2/auth/contents/situation": "situationList",
  "get:/wello/v2/auth/contents/situation/{situationId}": "getSituationPolicyList",
  "get:/wello/v2/auth/contents/pick": "welloPickList",
  "get:/wello/v2/auth/contents/pick/{welloPickId}": "welloPickPolicyList",
  "get:/wello/v2/auth/contents/feedback/{bestContentsId}": "bestContentsFeedback",
  "get:/wello/v2/auth/community/wello-news": "getCommunityWelloNewsList",
  "get:/wello/v2/auth/community/wello-news/{communityIdIdx}": "getCommunityWelloNews",
  "get:/wello/v2/auth/community/wello-news/feedback/{communityIdIdx}": "feedbackCommunityWelloNews",
  "get:/wello/v2/auth/benefit-notification/term-service-url": "getBenefitNotificationTermServiceUrl",
  "get:/wello/v2/auth/benefit-notification/situation-management-url": "getBenefitNotificationSituationManagementUrl",
  "get:/wello/v2/auth/benefit-notification/service-usage-agreement-url": "getBenefitNotificationServiceUsageAgreementUrl",
  "get:/wello/v2/auth/benefit-notification/service-usage-agreement-management-url": "getBenefitNotificationServiceUsageAgreementManagementUrl",
  "get:/wello/v2/auth/benefit-notification/public-service-detail-url": "getBenefitNotificationPublicServiceDetailUrl",
  "get:/wello/v2/auth/benefit-notification/privacy-usage-url": "getBenefitNotificationPrivacyUsageUrl",
  "get:/wello/v2/auth/benefit-notification/privacy-policy-url": "getBenefitNotificationPrivatePolicyUrl",
  "get:/wello/v2/auth/benefit-notification/main-info": "getBenefitNotificationMainInfo",
  "get:/wello/v2/auth/benefit-notification/fit-analysis": "getBenefitNotificationFitAnalysis",
  "get:/wello/v2/auth/benefit-notification/fit-analysis-result": "getBenefitNotificationFitAnalysisResult",
  "get:/wello/v2/auth/benefit-notification/application-results-url": "getBenefitNotificationApplicationResultsUrl",
  "get:/wello/v2/auth/banner": "bannerList",
  "get:/wello/v2/auth/apply-policy": "getWelloApplyPolicyList",
  "get:/wello/v1/auth/tour/article/{articleId}/feedback": "findArticleFeedback",
  "delete:/wello/v2/auth/member-wello/block/{blockedMemberId}": "deleteMemberWelloBlock",
  "delete:/wello/v2/auth/local-market/products/{productId}/inquiries/{inquiryId}": "deleteInquiry",
  "delete:/wello/v2/auth/local-market/cart-items/{cartItemId}": "deleteCartItem",
  "delete:/wello/v2/auth/family": "deleteWelloMemberFamily"
} as const;
